// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03346f77","455":"70eccf8b","977":"b0a4678a"}[chunkId] + ".chunk.js";
};